module.exports = __webpack_public_path__ + "static/assets/ea10c6cd20f58211c6338ce9b120597c.png";